export const SkillIds = {
    MISSILE: 'missile',
    LASER: 'laser',
    DRILL: 'drill',
    ORBIT: 'orbit',
    FISSURE: 'fissure',
    LIGHTNING: 'lightning',
    CHAIN: 'chain',
    DYNAMITE: 'dynamite',
    ORE_BONUS: 'oreBonus',
    UPGRADE_BONUS_MULTIPLICATIVE: 'upgradeBonusMult',
    UPGRADE_BONUS_ADDITIVE: 'upgradeBonusAdd',
    PRESTIGE_BONUS: 'prestigeBonus',
    RUBY_BONUS: 'rubyBonus',
    BLOCKS_BONUS: 'blocksBonus',
    DEPTH_BONUS: 'depthBonus',
    OFFLINE_BONUS: 'offlineBonus',
    FALL_BONUS: 'fallBonus',
    MINED_AUTOMATION: 'minedAutomation',
    PICK_AUTOMATION: 'pickAutomation',
    PRESTIGE_AUTOMATION: 'prestigeAutomation'
};